
export const appConstants = {
    AVI_USER_KEY: 'avi-user',
    AVI_USER_SESSION_EXPIRED: 'avi-user-session-expired',
    AVI_USER_SESSION_ERROR: 'avi-user-session-error',
    AVI_USER_SESSION_UNAUTHORISED_ERROR_MESSAGE: 'You do not have privilege to access page!',
    AVI_USER_SESSION_EXPIRED_MESSAGE: 'Your session has expired!',
    AVI_USER_SESSION_AUTHENTICATION_REQUIRED_MESSAGE: 'You need to login to access page!',
    APP_ID: 'Avicollect Web',
    APP_ID2: 'fid',
    INACTIVITY_EXPIRATION_LIMIT: 1200,
    //API URLS
    PAS_URL: (process.env.NODE_ENV === 'development') ? 'https://passerelle.test.vggdev.com' : window.env.passerelleUrl,
    // PAS_URL: (process.env.NODE_ENV === 'development') ? 'https://passerelle.staging.vggdev.com' : window.env.passerelleUrl,
    INVOICE_DOWNLOAD_URL: (process.env.NODE_ENV === 'development') ? 'https://bda.test.vggdev.com/LocalReports/ReportInvoice.aspx?invoicenumber=' : window.env.invoiceDownloadUrl,
    // TSC_URL: (process.env.NODE_ENV === 'development')? 'https://avipay.test.vggdev.com' : window.env.passerelleUrl,
    FMD_URL: (process.env.NODE_ENV === 'development') ? 'http://fmd.test.vggdev.com' : window.env.fmdUrl,
    AIRPORT_URL: (process.env.NODE_ENV === 'development') ? 'https://passerelle.test.vggdev.com/api/airport/' : window.env.airportUrl,
    AIRLINE_URL: (process.env.NODE_ENV === 'development') ? 'https://passerelle.test.vggdev.com/api/airline/' : window.env.airlineUrl,
    COUNTRY_URL: (process.env.NODE_ENV === 'development') ? 'https://passerelle.test.vggdev.com/api/Country/Search' : window.env.countryUrl,
    FLIGHT_DAYS_URL: (process.env.NODE_ENV === 'development') ? 'https://passerelle.test.vggdev.com/api/Days/search' : window.env.flightDaysUrl,
    FLIGHT_URL: (process.env.NODE_ENV === 'development') ? 'https://passerelle.test.vggdev.com/api/Flight/' : window.env.flightUrl,
    AVD_URL: (process.env.NODE_ENV === 'development') ? 'https://avd.test.vggdev.com' : window.env.avdUrl,
    AVP_URL: (process.env.NODE_ENV === 'development') ? 'https://avp.test.vggdev.com' : window.env.avpUrl,

    FORGOT_PASSWORD_URL: (process.env.NODE_ENV === 'development') ? "https://usermanager.test.vggdev.com/Account/ForgotPassword" : window.env.forgotPasswordUrl,
    RESET_PASSWORD_URL: (process.env.NODE_ENV === 'development') ? "https://usermanager.test.vggdev.com/Login/Login?access_token=" : window.env.resetPasswordUrl,
    EMAIL_DOMAIN_URL: (process.env.NODE_ENV === 'development') ? "https://usermanager.test.vggdev.com/Account/NewLogin?code=" : window.env.emailDomainUrl,
    DATA_ENTRY_URL: (process.env.NODE_ENV === 'development') ? "https://avicollectdataentry.test.vggdev.com/?access_token=" : window.env.dataEntryUrl,
    NCAA_ORG_ID: (process.env.NODE_ENV === 'development') ? 2003 : window.env.ncaaOrgId,
    IATA_PROCESS_NAME: (process.env.NODE_ENV === 'development') ? 'IATA Validation' : window.env.iataProcessName,
    MAKER_CHECKER_APP_ID: (process.env.NODE_ENV === 'development') ? 3 : window.env.makerCheckerAppId,
    FAQ_URL: (process.env.NODE_ENV === 'development') ? "https://tranzitechfaqapi.test.vggdev.com" : window.env.faqUrl,


    // DATA_ENTRY_URL: "http://avicollectdataentry.test.vggdev.com/?access_token=",

    //Action Types
    ADD_LOG: 'add_log',
    OPEN_MODAL: 'open_modal',
    CLOSE_MODAL: 'close_modal',
    CLEAR_MODAL: 'clear_modal',
    //API Status
    API_REQUEST_START: 'API_REQUEST_START',
    API_REQUEST_FULL_PAGE_START: 'API_REQUEST_FULL_PAGE_START',
    API_REQUEST_FINISH: 'API_REQUEST_FINISH',
    REQUEST_SUCCESS: 'REQUEST_SUCCESS',
    REQUEST_FAILURE: 'REQUEST_FAILURE',
    GET_REQUEST: 'get',
    POST_REQUEST: 'post',

    NOTIFY_SUCCESS: 'success',
    NOTIFY_ERROR: 'error',
    NOTIFY_INFO: 'info',
    NOTIFY_INVALID: 'in',
    NOTIFY_WARNING: 'warning',
    NOTIFY_DANGER: 'danger',

    FLIGHT_AIRPORT_DEPARTURE: "01",
    FLIGHT_AIRPORT_DESTINATION: "02",

    SUCCESS_RESPONSE: 1,
    ERROR_RESPONSE: 2,

    INVOICE_RECONCILIATION_SEARCH_MODE: 1,
    INVOICE_RECONCILIATION_PROCESS_MODE: 2,

    FTP_CREDENTIAL_SUCCESS_RESPONSE: 0,

    // sso roles 
    SSO_ROLES: {
        CLIENT_ADMIN: "client_admin",
        CLIENT_USER: "client_user"
    },

    ORGANIZATIONS : {
        AVITECH : "AVT",
        OTHERS : "Airline"
    },

    /*user Roles*/
    ROLES: {
        SUPER_ADMIN: "Super Admin",
        STAFF: "Staff",
        ADMIN: "Admin",
        BSP_ADMIN: "BSP",
        AIRLINE_ADMIN: "Airline_Admin",
        AIRLINE_STAFF: "Airline_Staff",
        NCAA_DATR: "NCAA DATR",
        VGG_SUPERADMIN: "VGG SuperAdmin",
        VGG_ADMIN: "VGG Admin",
        VGG_USER: "VGG User",
    },

    ROLES_PAGES: {
        SUPER_ADMIN: ['*'],
        ADMIN: ['/','maker-checker', 'search', 'iata', 'tsc', 'reports', 'pdm-report', 'pdm-data-entry', 'billed-per-airport'],
        NCAA_DATR: ['/','maker-checker', 'search', 'iata', 'tsc', 'reports', 'pdm-report', 'pdm-data-entry', 'billed-per-airport'],
        STAFF: ['maker-checker', 'search', 'reports', 'pdm-report', 'pdm-data-entry', 'billed-per-airport', 'iata'],
        BSP_ADMIN: ['/', 'search', 'upload', 'manifest', 'flight', 'iata', 'invoice', 'tsc', 'proforma', 'payment-reconciliation', 'unmatched-payments', 'pdm-report', 'pdm-data-entry', 'match-payment', 'unmatched-domestic-payment', 'iata-validation', 'iata-validation-page', 'billed-per-airport', 'final-destination-report'],
        AIRLINE_ADMIN: ['search', 'tsc','dispute-log','airline-wallet-history'],
        AIRLINE_STAFF: ['search', 'tsc', 'dispute-log', 'airline-wallet-history'],
        VGG_ADMIN: ['*'],
        VGG_SUPERADMIN: ['/','search', 'iata', 'reports', 'pdm-report', 'proforma', 'invoice', 'tsc', 'payment-reconciliation', 'billed-per-airport'],
        VGG_USER: ['/','search', 'iata', 'reports', 'pdm-report', 'proforma', 'invoice', 'tsc', 'payment-reconciliation', 'billed-per-airport'],

    },
    PAGES_INDEX: [
        { name: 'timeline', index: 0 }, { name: 'search', index: 30 }, { name: 'manifest', index: 30 },
        { name: 'iata', index: 7 }, { name: 'invoice', index: 8 }, { name: 'tsc', index: 9 }, { name: 'ftp-credentials', index: 10 },
        { name: 'reports', index: 11 }, { name: 'proforma', index: 12 }, { name: 'payment-reconciliation', index: 13 },
        { name: 'unmatched-payments', index: 13 }, { name: 'unmatched-domestic-payment', index: 13 }, { name: 'pdm-report', index: 50 },
        { name: 'workflow', index: 77 }, { name: 'iata-validation', index: 107 }, { name: 'pdm-data-entry', index: 50 },
        { name: 'billed-per-airport', index: 20 },
    ],
    APP_ENTITIES: {
        CREATE_AIRLINE: "CreateAirline",
        UPDATE_AIRLINE: "UpdateAirline",
        CREATE_AIRPORT: "CreateAirport",
        UPDATE_AIRPORT: "UpdateAirport",
        CREATE_FLIGHT: "CreateFlight",
        UPDATE_FLIGHT: "UpdateFlight",
        CREATE_FTP_CREDENTIAL: "CreateFTPCredential",
        DELETE_FTP_CREDENTIAL: "DeleteFTPCredential",
        MATCH_PAYMENT: "MatchPayment",
        UPLOAD_PAYMENT: "UploadPayment",
        CREATE_WORKFLOW: "CreateWorkflow",
        UPDATE_WORKFLOW: "UpdateWorkflow",
        CREATE_FLAG_METRICS: "CreateFlagMetrics",
        CREATE_AIRLINE_LOCATION: "CreateAirlineLocation",
        UPDATE_AIRLINE_LOCATION: "UpdateAirlineLocation",
        CREATE_TICKET_SETUP: "CreateTicketSetup",
        UPDATE_TICKET_SETUP: "UpdateTicketSetup",
        CREATE_AIRLINE_WALLET: "CreateAirlineWallet"

    },
    MAKER_CHECKER_STATUS: {
        PENDING: 0,
        APPROVED: 1,
        REJECTED: 2
    },

    NOTIFICATION_TYPES: {
        PULL_MODE: 0,
        MANIFEST_SUCCESS: 1,
        MANIFEST_FAILED: 2,
        MANIFEST_PENDING: 3,
        MANIFEST_PROCESSING: 4,
        MANIFEST_PARTIAL: 5,
        PULL_FAILED: 6,
        AIRLINE_ERROR: 7
    },

    /*Period Picker dropdown*/
  THISWEEK: 'THISWEEK',
  TODAY: 'TODAY',
  THISMONTH: 'MONTH',
  LASTMONTH: 'LASTMONTH',
  THISYEAR: 'THISYEAR'
};



// WEBPACK FOOTER //
// ./src/_constants/app.constants.js